/**
 * @desc 红人领用管理-转交领用
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.Response;
export function request(
  body: defs.kol.UserCelebrityTransferRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/useCelebrity/transfer`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
